"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchReliability = fetchReliability;
var _assert = require("./assert");
var _getReliabilityDetailsWeb = require("../../shared/repositories/newbuilding-reliability/v2/get-reliability-details-web");
async function fetchReliability(_ref) {
  let {
    params,
    httpApi,
    logger
  } = _ref;
  try {
    const response = await (0, _getReliabilityDetailsWeb.fetchGetReliabilityDetailsWeb)({
      httpApi,
      parameters: params,
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']]
        }
      }
    });
    (0, _assert.assertBadHttpStatus)(response);
    return response.response.reliabilityDetails || null;
  } catch (error) {
    logger.error(error, {
      domain: 'src/services/fetchLayouts'
    });
    return null;
  }
}